import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import IconButton from "@mui/material/IconButton";
import BackIcon from "@mui/icons-material/ArrowBackIos";
import Typography from "@mui/material/Typography";
const ViewHeader = ({
  classes,
  onBackClick,
  title
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.header
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: onBackClick,
    size: "large"
  }, /*#__PURE__*/React.createElement(BackIcon, null)), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, title));
};
const styles = () => ({
  header: {
    display: "flex",
    alignItems: "center"
  }
});
export default withStyles(styles)(ViewHeader);
ViewHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  onBackClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};